import { SPINNING_WHEEL_TYPE } from "../quests/quest.enums";
import { z } from "zod";

export const GetSpinningWheelSlotsDtoSchema = z.object({
  spinningWheelType: z.nativeEnum(SPINNING_WHEEL_TYPE),
});
export type GetSpinningWheelSlotsDto = z.infer<typeof GetSpinningWheelSlotsDtoSchema>;

export const GenerateSpinningWheelResultDtoSchema = z.object({
  questId: z.coerce.number().positive(),
});
export type GenerateSpinningWheelResultDto = z.infer<typeof GenerateSpinningWheelResultDtoSchema>;

export const CompleteSpinningWheelQuestDtoSchema = z.object({
  id: z.uuid(),
});
export type CompleteSpinningWheelQuestDto = z.infer<typeof CompleteSpinningWheelQuestDtoSchema>;

export const SpinningWheelEligibilityResponseSchema = z.object({
  isEligible: z.boolean(),
  questId: z.number().optional(),
  reason: z.string().optional(),
});
export type SpinningWheelEligibilityResponse = z.infer<typeof SpinningWheelEligibilityResponseSchema>;
